module.exports = __webpack_public_path__ + "static/media/smallLogo.ad4766aa.png";